export default __webpack_public_path__ + "static/media/pointblender.62dca65c.webp";